// extracted by mini-css-extract-plugin
export default {"songsContainer":"SongsContainer_songsContainer__mbDuV"};